export default {
  init() {
    document.querySelectorAll('input[name="origem_pagina"]').forEach(input => {
      input.value = document.title;
    });

    document.querySelectorAll('input[name="origem_url"]').forEach(input => {
      input.value = window.location.href;
    });

    $('input[name="telefone"]').mask('(00) 00000-0000');

    /* ===============================
     * Fancybox
     * =============================== */
    if (window.jQuery && jQuery.fn.fancybox) {
      jQuery('[data-fancybox]').fancybox();
    }

    // --- Animações com IntersectionObserver ---
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -80px 0px'
    });

    document.querySelectorAll('[class*="animate-"]').forEach(el => observer.observe(el));

    /* ===============================
     * Header sticky (performático)
     * =============================== */
    const header = document.getElementById('myHeader');
    if (header) {
      let lastScrollY = window.pageYOffset;
      let ticking = false;

      const updateHeader = () => {
        header.classList.toggle('sticky', lastScrollY > 1);
        ticking = false;
      };

      window.addEventListener('scroll', () => {
        lastScrollY = window.pageYOffset;
        if (!ticking) {
          requestAnimationFrame(updateHeader);
          ticking = true;
        }
      }, { passive: true });

      updateHeader();
    }

    /* ===============================
     * Menu Mobile
     * =============================== */
    const body = document.body;
    const mobileButton = document.querySelector('button.menu-mobile-button');

    // --- Submenu mobile (clique) ---
    $('.nav li:has(> .sub-menu) > a').on('click', function (e) {
      e.preventDefault();

      const $sub = $(this).next('.sub-menu');
      const isActive = $sub.hasClass('active');

      $(this).closest('ul').find('> li > .sub-menu.active').removeClass('active');

      if (!isActive) {
        $sub.addClass('active');
      }
    });

    // --- Fecha submenu ao clicar fora (registrado UMA vez) ---
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.nav').length) {
        $('.nav .sub-menu.active').removeClass('active');
      }
    });

    const closeMobileMenu = () => {
      body.classList.remove('menu-show');
      document.querySelectorAll(
        '.menu.navbar-collapse, .nav-primary'
      ).forEach(el => el.classList.remove('in', 'show'));

      document
        .querySelectorAll('.navbar-toggle, .menu-mobile-button')
        .forEach(el => el.classList.remove('fechar', 'is-open'));
    };

    if (mobileButton) {
      mobileButton.addEventListener('click', () => {
        mobileButton.classList.toggle('is-open');
        body.classList.toggle('menu-show');

        const navFixed = document.querySelector('.nav-fixed');
        if (navFixed) {
          navFixed.classList.toggle('menu-show');
        }
      });
    }

    /* ===============================
    * Scroll suave por âncora
    * =============================== */
    const menu = document.querySelector('#menu-menu');

    if (menu) {
      menu.addEventListener('click', function (e) {
        const link = e.target.closest('a');
        if (!link) return;

        // Extrai o segmento do href: "/inicio/" → "inicio"
        const href = link.getAttribute('href') || '';
        const segment = href.replace(/^.*\/([^\/]+)\/?$/, '$1');

        const target = document.getElementById(segment);
        if (!target) return;   // se não existe seção com esse id, comportamento padrão

        e.preventDefault();

        const offset =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          75;

        window.scrollTo({
          top: offset,
          behavior: 'smooth'
        });

        closeMobileMenu();
      });
    }

    /* ===============================
     * SVG inline com cache
     * =============================== */
    const svgCache = {};

    document.querySelectorAll('img.svg').forEach(img => {
      const src = img.getAttribute('src');
      if (!src) return;

      const replaceSVG = svg => {
        const clone = svg.cloneNode(true);

        if (img.id) clone.id = img.id;
        if (img.className) clone.setAttribute(
          'class',
          `${img.className} replaced-svg`
        );

        clone.removeAttribute('xmlns:a');

        if (!clone.getAttribute('viewBox') &&
            clone.getAttribute('width') &&
            clone.getAttribute('height')) {
          clone.setAttribute(
            'viewBox',
            `0 0 ${clone.getAttribute('width')} ${clone.getAttribute('height')}`
          );
        }

        img.replaceWith(clone);
      };

      if (svgCache[src]) {
        replaceSVG(svgCache[src]);
      } else {
        fetch(src)
          .then(res => res.text())
          .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'image/svg+xml');
            const svg = doc.querySelector('svg');
            if (!svg) return;
            svgCache[src] = svg;
            replaceSVG(svg);
          });
      }
    });

    if ($('.slick-trajetoria').length) {
      $('.slick-trajetoria').slick({
        autoplay: false,
        dots: false,
        centerMode: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>',
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        responsive: [
          { breakpoint: 1440, settings: { slidesToShow: 4, slidesToScroll: 4 } },
          { breakpoint: 992,  settings: { slidesToShow: 3, slidesToScroll: 3 } },
          { breakpoint: 768,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
          { breakpoint: 525,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
    }

    if ($('.slick-filiacao').length) {
      $('.slick-filiacao').slick({
        autoplay: false,
        dots: false,
        centerMode: false,
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        infinite: false,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 5, slidesToScroll: 5, dots: true } },
          { breakpoint: 992,  settings: { slidesToShow: 4, slidesToScroll: 4, dots: true } },
          { breakpoint: 768,  settings: { slidesToShow: 3, slidesToScroll: 3, dots: true } },
          { breakpoint: 425,  settings: { slidesToShow: 2, slidesToScroll: 2, dots: true } },
        ],
      });
    }
  },
  finalize() {
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js